var _rect, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 160,
    viewBox: "0 0 230 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 179.707,
    y: 5.88235,
    width: 50.5882,
    height: 50.5882,
    rx: 25.2941,
    transform: "rotate(90 179.707 5.88235)",
    fill: "#EBE9EF",
    fillOpacity: 0.3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.4129,
    cy: 126.471,
    rx: 5.29412,
    ry: 5.29412,
    transform: "rotate(90 54.4129 126.471)",
    fill: "#EBE9EF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.588,
    cy: 61.1765,
    rx: 3.52941,
    ry: 3.52941,
    transform: "rotate(90 185.588 61.1765)",
    fill: "#EBE9EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.63 128.067C139.59 128.067 163.067 104.59 163.067 75.6303C163.067 46.6701 139.59 23.1933 110.63 23.1933C81.6702 23.1933 58.1934 46.6701 58.1934 75.6303C58.1934 104.59 81.6702 128.067 110.63 128.067Z",
    stroke: "#9D96AF",
    strokeWidth: 2.35294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.686 112.687L171.807 136.808",
    stroke: "#9D96AF",
    strokeWidth: 2.35294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8396 51.5906C89.0312 58.3989 91.7908 72.1968 102.003 82.4092C112.216 92.6216 126.014 95.3812 132.822 88.5728C139.63 81.7647 136.87 67.9667 126.658 57.7544C116.446 47.5419 102.648 44.7824 95.8396 51.5906Z",
    stroke: "#9D96AF",
    strokeWidth: 2.35294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7579 91.6542C82.5456 81.4419 79.786 67.644 86.5944 60.8357L95.8397 51.5901C89.0318 58.3984 91.7914 72.1964 102.004 82.4087C112.216 92.6212 126.014 95.3808 132.822 88.5724L123.577 97.8182C116.768 104.626 102.97 101.867 92.7579 91.6542Z",
    stroke: "#9D96AF",
    strokeWidth: 2.35294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.002 82.409L92.7561 91.6548",
    stroke: "#9D96AF",
    strokeWidth: 2.35294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.104 90.8821L105.858 100.127",
    stroke: "#9D96AF",
    strokeWidth: 2.35294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5312 69.3074L84.2854 78.553",
    stroke: "#9D96AF",
    strokeWidth: 2.35294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no_results.ec3ce45978cfde887b3d6b4a6dd13a68.svg";
export { ForwardRef as ReactComponent };